import React from 'react'

import { useSearchParams } from 'react-router-dom'

import moment from 'moment'

import { useTranslation } from 'react-i18next'

import { IPlanMenuCloseDimensionDto } from 'core/api/dto/PlanMenuCloseDto'

import { MilletType } from 'core/api/dto/PlanMenuCloseDto'
import { DimensionType } from 'core/api/dto/BuffetReportDto'
import { ITag } from 'core/api/dto/TagsDto'

export interface IPlanMenuCloseDimensionDtoNew {
  id: number
  guid: string
  photoUrl: string
  thermoPhotoUrl: string
  dishStandardImage: string
  dishStandardWeight: number
  temperature: number | null
  dimensionDatetime: string
  weight: number | null
  milletWeight: number
  millet: MilletType
  dishTempMin: number
  dishTempMax: number
  tempChecker: number
  quantity: number
  dimensionType: DimensionType
  comment: string
  dishImplementationTime: number | null
  implementationTime: number
  implementationTimeExceeded: number | null
  dimensionTags: ITag[]
}

interface IFrozeItemProps {
  dimensionItem: IPlanMenuCloseDimensionDto
  index: number
  withTaskAddButton?: boolean
  onClick?: () => void
}

export const FrozeCloseItem = ({
  dimensionItem,
  index,
  withTaskAddButton,
  onClick,
}: IFrozeItemProps) => {
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()
  const currentDimensionId = searchParams.get('dimension')?.split('_')[0] || 0
  const onDimensionHandler = () => {
    searchParams.set('dimension', `${dimensionItem.id}`)
    searchParams.set('index', `${index}`)
    setSearchParams(searchParams.toString(), { replace: true })
  }

  return (
    <div
      className={`froze-item${
        dimensionItem.id === Number(currentDimensionId || 0) ? ' active' : ''
      } froze-item-close`}
      onClick={() => { onDimensionHandler(); /* onClick?.() */ }}
    >
      <div className="number">
        <span>{index}</span>
      </div>
      <div className="froze-info">
        <div className="">
          {!!dimensionItem?.millet?.isDefault && (
            <div className="flex-end">
              <div className={`status-block-item`}>
                <span>{t(`Назначить тару`)}</span>
              </div>
            </div>
          )}

          <div className="froze">
            <span>{t('Замер')}</span>
            <div className="dotes" />
            <span>
              <b>{moment.parseZone(dimensionItem.dimensionDatetime).format('HH:mm')}</b>
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
